<!-- src/components/ReconciliationStat.vue -->
<template>
  <div class="page-card" v-if="enableCustomerStatement">
    <div class="section-header">
      <span class="title">对账统计</span>
      <el-button size="small" v-if="!singleRow" @click="toggleExpand">
        {{ isExpanded ? "收起" : "展开" }}
      </el-button>
    </div>
    <div class="stat-grid-wrapper">
      <div class="stat-grid" ref="statGrid" :class="{ 'is-collapsed': !isExpanded }">
        <div class="stat-card" v-for="item in displayStatCards" :key="item.label">
          <div class="label">
            {{ item.label }}
            <el-tooltip v-if="item.tooltip" class="item" effect="dark" :content="item.tooltip" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div class="value">{{ item.price ? "￥" : "" }}{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ontickInfo } from "@/api/reconciliation";
import { mapState } from "vuex";
export default {
  name: "ReconciliationStat",
  data() {
    return {
      isExpanded: true,
      singleRow: false,
      statItems: {}
    };
  },
  computed: {
    ...mapState("companyInfo", {
      company: state => state.company
    }),
    // 商城是否启用客户往来账展示
    enableCustomerStatement() {
      return !!(this.company.setting || {}).enableCustomerStatement;
    },
    // 往来账展示项，与 customerStatementShows 枚举对应：0 欠款金额；1 应收账款余额；2 预收账款余额；3 信用额度；4 账期；5 待支付；6 应付款余额；7 预付款余额；8 剩余额度
    customerStatementShows() {
      return (this.company.setting && this.company.setting.customerStatementShows) || [];
    },
    statCards() {
      return [
        {
          label: "欠款",
          key: 0,
          price: true,
          value: this.statItems.receCur,
          tooltip: "欠款金额 = 应付金额 - 应收金额"
        },
        { label: "待支付", key: 5, price: true, value: this.statItems.payAmount },
        { label: "应收金额", key: 1, price: true, value: this.statItems.receVirArrear },
        { label: "应付金额", key: 6, price: true, value: this.statItems.payCur },
        { label: "预付金额", key: 7, price: true, value: this.statItems.prePayCur },
        { label: "信用额度", key: 3, price: true, value: this.statItems.credit },
        { label: "剩余信用额度", key: 8, price: true, value: this.statItems.ye },
        { label: "账期", key: 4, value: this.statItems.zq },
        { label: "对账日", key: 9, value: this.statItems.startZq },
        { label: "预收金额", key: 2, price: true, value: this.statItems.preReceCur }
      ];
    },
    // 未启用往来账展示时不展示任何卡片；启用后仅展示 customerStatementShows 中勾选的项
    displayStatCards() {
      if (!this.enableCustomerStatement) return [];
      return this.statCards.filter(item => this.customerStatementShows.includes(item.key));
    }
  },
  watch: {
    // 展示项变化后重新测量是否单行，以决定是否显示展开/收起按钮
    displayStatCards() {
      this.$nextTick(() => this.updateSingleRow());
    }
  },
  methods: {
    getInfo() {
      ontickInfo().then(res => {
        console.log("对账信息", res);
        this.statItems = res;
      });
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    // 判断所有统计卡片是否都处于同一行
    updateSingleRow() {
      const grid = this.$refs.statGrid;
      if (!grid) return;
      const cards = grid.querySelectorAll(".stat-card");
      if (!cards.length) {
        this.singleRow = false;
        return;
      }
      const firstTop = cards[0].offsetTop;
      this.singleRow = Array.prototype.every.call(cards, item => item.offsetTop === firstTop);
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {
    this.$nextTick(() => this.updateSingleRow());
    window.addEventListener("resize", this.updateSingleRow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateSingleRow);
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.page-card {
  background: #fff;
  border-radius: 8px;
  /* padding: 20px 24px; */
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px;
  /* margin-bottom: 18px; */
  flex-wrap: wrap;
  background-color: rgba(249, 249, 249, 1);
  gap: 12px;
}
.section-header .title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  display: flex;
  align-items: center;
}
/* .section-header .title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 18px;
  background: #409eff;
  border-radius: 2px;
  margin-right: 10px;
} */
.stat-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px 0;
  transition: all 0.1s ease;
  overflow: hidden;
  padding: 12px;
}
.stat-grid.is-collapsed {
  max-height: 60px !important;
  /* padding: 0; */
  /* margin: 0; */
  /* opacity: 0; */
  /* pointer-events: none; */
}
.stat-card {
  /* background: #fafcfe; */
  border-right: 1px solid #6666;
  /* border-radius: 8px; */
  /* padding: 16px 18px; */
  /* transition: all 0.1s; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
/* .stat-card:hover {
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.12);
  border-color: #c6e2ff;
} */
.stat-card .label {
  font-size: 14px;
  color: #666666;
  /* margin-bottom: 6px; */
}
.stat-card .value {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}
.stat-card .value .unit {
  font-size: 13px;
  font-weight: 400;
  color: #909399;
  margin-left: 4px;
}
.stat-card .value.primary {
  color: #409eff;
}
.stat-card .value.success {
  color: #67c23a;
}
.stat-card .value.warning {
  color: #e6a23c;
}
.stat-card .value.danger {
  color: #f56c6c;
}
.stat-card .value.info {
  color: #909399;
}
.stat-grid-wrapper .stat-grid {
  max-height: 800px;
  /* transition: max-height 0.4s ease, opacity 0.3s ease, margin 0.3s ease; */
  opacity: 1;
  margin-bottom: 0;
}
.stat-grid-wrapper .stat-grid.is-collapsed {
  max-height: 60px !important;
  /* opacity: 0; */
  /* margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0; */
  overflow: hidden;
  /* pointer-events: none; */
}
@media (max-width: 1200px) {
  .stat-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 992px) {
  .stat-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 768px) {
  .stat-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .stat-grid {
    grid-template-columns: 1fr;
  }
}
</style>
